export const SOROSILICATE_LOGIC = {
  description: "Sorosilicates (Double Island Silicates) Identification Rules",
  
  coreRules: `
=== 硅酸盐之对状硅酸盐鉴定法则 (Sorosilicates / Double Island Silicates Protocol) ===

对状硅酸盐的核心结构是两个硅氧四面体共用一个氧原子相连 ($Si_2O_7$)。这个家族最著名的代表是绿帘石族矿物，它们广泛存在于变质岩和热液蚀变带中，是地质学家眼中的“温标”和“压标”。

[10.1 绿帘石家族 (The Epidote Group) - 变质带的调色盘]
这个家族的矿物晶体通常呈柱状，并且柱面上常常带有明显的平行生长纹（条纹）。
*   **绿帘石 (Epidote)**: 绝对的颜色锚点！寻找特征性的**“开心果绿” (Pistachio-green)、黄绿色至深绿色**。具有强烈的玻璃光泽，通常呈现带有明显平行纵纹的长柱状晶体，或者致密的放射状、粒状集合体。只要看到这种特有的带黄调的绿色柱状物，首选绿帘石。
*   **斜黝帘石 (Clinozoisite)**: 绿帘石的富铝贫铁亲戚。外形与绿帘石极像（带平行纹的柱状），但颜色更加“素雅”，通常是**浅灰绿、灰白色、淡黄褐色**，没有绿帘石那种浓郁的开心果绿。
*   **褐帘石 (Allanite)**: 含有稀土和放射性元素的变种。通常呈现**褐黑色、沥青黑色 (Dark brown to black)**，具有沥青光泽或半金属光泽。在母岩中，它的周围往往会有因为放射性造成的“晕圈”。
*   **黝帘石家族 (Zoisite) 及其变种**:
    *   **黝帘石 (Zoisite)**: 本体通常是灰色、灰褐色的柱状晶体（斜方晶系，与绿帘石单斜晶系不同，但肉眼难辨），但它的两个变种闻名遐迩！
    *   **锰黝帘石 (Thulite)**: **终极视觉锚点！**呈现极其娇艳、不透明的**玫瑰红色、粉红色 (Rose-red, pink)**。它通常是致密的块状集合体。只要看到石头呈现这般毫无透明度但极度致密的“少女粉”或红肉色，立刻锁定锰黝帘石。
    *   **坦桑石 (Tanzanite)**: 宝石级黝帘石。寻找**极其通透的紫蓝色、蓝紫色 (Violet-blue, Sapphire-blue)**。它具有极其强烈的多色性（从不同角度看呈现蓝、紫、甚至勃艮第红）。

[10.2 结构不对称与接触交代矿物]
*   **异极矿 (Hemimorphite)**: 锌的硅酸盐。
    *   **形态锚点**: 名字来源于它的**异极性 (Hemimorphic)**——晶体的两端形状完全不同（一端类金字塔，一端常是平的）。常见形态分为两种：带棱角的**白色/无色板片状、透明至半透明刀片状晶簇**（如你图中所展示的），或者是**蓝绿色、天蓝色的葡萄状/肾状皮壳**（长得极像菱锌矿或硅孔雀石，但异极矿有发散的结晶结构）。
*   **符山石 (Vesuvianite / Idocrase)**: 接触交代的标志产物（如夕卡岩）。
    *   **形态锚点**: 寻找**极其粗壮的、短柱状 (Stubby, blocky) 的正方体或八边形晶体**，端面通常较平坦。颜色多为**褐绿色、黄褐色、黄绿色 (Brownish-green to yellow-brown)**。它看起来比绿帘石更加“笨重”且呈现方块感，光泽常为油脂状或强玻璃光泽。

`,

  diagnosticTests: `
- 寻找“开心果绿”：如果岩石中含有大量带平行条纹的黄绿色柱状或粒状晶体，立刻锁定绿帘石。如果是颜色泛白的同类柱体，则是斜黝帘石。
- 寻找“玫瑰粉红”：如果看到致密不透明的粉红色/玫瑰红块状岩石，它是锰黝帘石 (Thulite)。
- 如果见到纯净通透无比的蓝紫色宝石晶体，那是坦桑石。
- 观察晶体形态感觉：如果是褐黑色发沥青光泽的致密块，考虑放射性褐帘石。如果是黄褐/绿褐色、显得很笨重方正的短柱子，考虑符山石。
- 如果矿物呈白色/透明细板片状结晶聚集，或呈现天蓝色葡萄状皮壳，结合铅锌矿找矿背景，它是异极矿。
`
};
